import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import PropTypes from 'prop-types';
import NotificationTasksCard from '../../NotificationTaskCard';
import NotificationTaskDocumentBox from './NotificationTaskDocumentBox';
import CTextAreaSimple from '../../../../components/Common/CTextAreaSimple';
import MessageBox from '../../../../components/Common/Message/MessageBox';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import { __MessageTypes, enum__NOTIFICATION_CLASS, enum__NOTIFICATION_INBOX_TYPE } from '../../../../common/Dictionaries';
import { isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../common/Helpers';
import { addAchievementComment, addValidationComment, setNotificationCompleted, setNotificationViewed } from '../../../../services/sNotificationAlerts/notificationAlerts.service';
import { useGetNotificationDetails } from '../../../../hooks/services/NotificationTask/useOfNotificacionTask';
import { action_setNotificacionTaskList, action_setNotificacionTaskListFiltred, action_setNotificacionTaskMenuItems } from '../../../../reducers/actions/NotificationTasks/actions';

const AchieveValidateNotificationDialog = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    
    const { 
        inputParam_IsModalOpen = null, 
        inputParam_NotificationTask = null,     
        inputParam_NotificationClassId = null,     
        inputParam_IsApprove = null,     
        inputParam_SetterIsModalOpen = null,   
        inputParam_HandleAction = null,   
    } = props;
    
    const { 
        _notificationTaskDataList: notificationTaskDataList,
        _notificationTaskDataListFiltred: notificationTaskDataListFiltred,
        _notificationTaskMenuData: notificationTaskMenuData,
    } = useSelector((state) => state.notificationTaskState);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const handleSaveButtonClick = async (achieve) => {
        await setNotificationViewed(inputParam_NotificationTask.id, true).then(async (response) => {
            if (response.data.succeeded) {
                setNotificationCompleted(inputParam_NotificationTask.id, achieve).then((responseCompleted) => {
                    if (responseCompleted.data.succeeded) {
                        notificationTaskDataList.map(item => { if (item.id === inputParam_NotificationTask.id) { item.completed = true; } })
                        notificationTaskDataListFiltred.map(item => { if (item.id === inputParam_NotificationTask.id) { item.completed = true; } })

                        notificationTaskMenuData.map(itemMenu => {
                            if (itemMenu.item1 === enum__NOTIFICATION_INBOX_TYPE.UNFULFILLED) { itemMenu.item2 = itemMenu.item2 -1; }
                            if (itemMenu.item1 === enum__NOTIFICATION_INBOX_TYPE.COMPLETED) { itemMenu.item2 = itemMenu.item2 +1; }
                        })

                        dispatch(action_setNotificacionTaskMenuItems(notificationTaskMenuData));   
                        dispatch(action_setNotificacionTaskList(notificationTaskDataList));
                        dispatch(action_setNotificacionTaskListFiltred(notificationTaskDataListFiltred));

                        inputParam_HandleAction && inputParam_HandleAction(achieve ? 'complete' : 'reject');
                        inputParam_SetterIsModalOpen && inputParam_SetterIsModalOpen(false);
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }

        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    };

    const onCancelModal = () => {
        inputParam_SetterIsModalOpen(false);
    }

    return (
        <Dialog
            hidden={!inputParam_IsModalOpen}
            onDismiss={onCancelModal}
            minWidth={850}
            maxWidth={1300}
            dialogContentProps={{
                type: DialogType.normal,
                styles: {header : { borderBottom: "2px solid #e8e8e8" }},
                title: t('data-lang-boxname-warning'),
            }}
            modalProps={{ isBlocking: true, }}
            >
                {
                    inputParam_NotificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE &&
                    <div>
                        {t('data-lang-msg-approvecoachieve')}
                    </div>
                }
                {
                    inputParam_NotificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE &&
                    <>
                        {
                            inputParam_IsApprove &&
                            <div>
                                {t('data-lang-msg-approvecovalidation')}
                            </div>
                        }
                        {
                            !inputParam_IsApprove &&
                            <div>
                                {t('data-lang-msg-rejectcovalidation')}
                            </div>
                        }
                    </>
                }
            
            <DialogFooter>
                <Row>
                    <Col>
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                </Row>
                <Row>
                    <Col></Col>
                    <Col className='col-auto me-auto'>
                        <PrimaryButton onClick={ () => handleSaveButtonClick(true) }>{ inputParam_NotificationClassId === enum__NOTIFICATION_CLASS.CO_TO_ACHIEVE ? t('data-lang-btn-achieve') : t('data-lang-btn-validate') }</PrimaryButton>
                    </Col>
                    {
                        inputParam_NotificationClassId === enum__NOTIFICATION_CLASS.CO_TO_VALIDATE &&
                        <Col className='col-auto me-auto'>
                            <DefaultButton onClick={ () => handleSaveButtonClick(false) }>{ t('data-lang-btn-reject') }</DefaultButton>
                        </Col>
                    }
                    <Col className='col-auto me-auto'>
                        <DefaultButton onClick={ onCancelModal }>{ t('data-lang-btn-cancel') }</DefaultButton>
                    </Col>
                </Row>
            </DialogFooter>
        </Dialog>
    );
};

AchieveValidateNotificationDialog.propTypes = {
    inputParam_NotificationTask: PropTypes.object.isRequired,  
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,  
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,      
};

export default AchieveValidateNotificationDialog;